import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, IvfEmbryoTransferAttemptByCycleCodeController, IvfEmbryoTransferAttemptByCycleCodeRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'embryotransfer',
  templateUrl: './embryotransfer.component.html',
  styleUrls: ['./embryotransfer.component.scss']
})

export class EmbryotransferPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public PatientId: string;
  public ProtocolStart: string;
  public ProtocolEnd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public ActorCode: any;
  public Age: string; 
  public CycleNo: string;
  public CycleType: string;
  public Surgeon: string;
  public AsstSurgeon: string;
  public Embryologist: string;
  public Anaesthesiologist: string;
  public Anaesthesia: string;
  public PlannedTime: string;
  public ActualDate: string; 
  public ActualTime: string;
  public Doc: string;
  public CultureMedia: string;
  public Method: string;
  public CatheterType: string;
  public CatheterUsed: string;
  public SpeculumUsed: string;
  public CervicalCleaning: string;
  public RetainedEmbryos: string;
  public Fragmentation: string;
  public CervicalMucus: string;
  public Technique: string;
  public BloodOnCatheter: string;
  public Retransfer: string;
  public EmbryoTransfer: string;
  public OvulationTriggerDate: string;
  public OvulationTriggerTime: string;
  public TransferedCount: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public TotalCout: number;
  public TransferDate: string;
  public TransferDatenew: string;
  public CycleCode: any;
  public ActivityCode: any;
  public Code: any;
  public DSADOC: string;
  public DSASTIMULATION: string;
  public DSAANTAG: string;
  public Date: Date;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  TransferEndDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;

  CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
  FollicularPickupEndInfo: FollicularPickUpsByCodeController;
  CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

  LoadOvariesData() {
    //alert("ScansData")
    this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularPickUpsByCodeController();
  }

  GetFollicularPickUpsByCodeController() {
    this.StartRefreshing();
    this.CurrentFollicularPickUpsByCodeRequest.ConditionalOperator = 20;
    this.CurrentFollicularPickUpsByCodeRequest.TreatmentCycle = this.CycleCode;
    this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.CycleCode;
    //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
    //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
    //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
    //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
          this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];


          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadTestData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.ActivityCode = this.route.snapshot.paramMap.get('ActivityCodenew');
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    this.StartRefreshing();
    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
      this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.ActivityCode;
      this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
      this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.ActorCode, this.TransferDatenew)[0].CycleActivityCode;
    /*this.CurrentIvfCycleTestByCodeRequest.ActivityCode = 0;*///this.GetCycleActivity(this.ActorID,this.TransferDate);
    //this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.SelectedpatientDetails.PickUpTreatmentCycle;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.PickUpCycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadMedicineData();
          //   this.LoadGuardian();
          //this.LoadMessages();     
          
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
  CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

  LoadMedicineData() {
    //alert("ScansData")
    this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.ActivityCode = this.route.snapshot.paramMap.get('ActivityCodenew');
    //this.ActivityCode = this.route.snapshot.paramMap.get('ActivityCode');
    this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMedicineByCodeController();
  }

  GetIvfCycleMedicineByCodeController() {
    this.StartRefreshing();
    this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
      this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.ActivityCode;
      this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
      this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;    
    //this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.SelectedpatientDetails.PickUpTreatmentCycle;
    ////this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.SelectedpatientDetails.PickUpCycleActivity;
    ////alert(this.FormattedCode);
    this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadSingle();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
  TransferrableList: SingleWellCultureByCycleCodeController[];
  DiscardedList: SingleWellCultureByCycleCodeController[];
  CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
  LoadSingle() {

    this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
    //this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');

    this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetSingleWellCultureByCycleCodeController()
  }
  GetSingleWellCultureByCycleCodeController() {
    this.StartRefreshing();

    this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
    this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;
          this.TotalCout = this.CurrentSingleWellCultureByCycleCodeController.length;
          this.TransferrableList = this.ApiResData.Result;
          this.DiscardedList = this.ApiResData.Result;
          var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
            function (a) {
              return a.IsFrozen == true
            });
          this.CurrentSingleWellCultureByCycleCodeController = list;
          this.FrozenCount = this.CurrentSingleWellCultureByCycleCodeController.length;
          var listTransferrable = this.TransferrableList.filter(
            function (b) {
              return b.IsTransferrable == true;
            });
          this.TransferrableList = listTransferrable;
          this.TransferedCount = this.TransferrableList.length;
          var listDiscarded = this.DiscardedList.filter(
            function (c) {
              return c.isDisCarded == true;

            });
          this.DiscardedList = listDiscarded;
          this.DiscardedCount = this.DiscardedList.length;
          //alert(this.TransferedCount);
          //alert(this.TransferrableList[1].WellNo);
          // alert(this.CurrentSingleWellCultureByCycleCodeController[0].WellNo);
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadEmbryoTransfer();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfEmbryoTransferAttemptByCycleCodeController: IvfEmbryoTransferAttemptByCycleCodeController[];
  //EmbryoTransFerEndInfo: IvfEmbryoTransferAttemptByCycleCodeController;
  CurrentIvfEmbryoTransferAttemptByCycleCodeRequest: IvfEmbryoTransferAttemptByCycleCodeRequest;
  TreatmentCycleCode: any;
  LoadEmbryoTransfer() {
    this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest = new IvfEmbryoTransferAttemptByCycleCodeRequest();
    //this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.ConditionalOperator = 1;
    //this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoTransferAttemptByCycleCodeController();
  }
  GetIvfEmbryoTransferAttemptByCycleCodeController() {
    this.StartRefreshing();


    this.actorservice.GetIvfEmbryoTransferAttemptByCycleCodeController(this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfEmbryoTransferAttemptByCycleCodeController = this.ApiResData.Result;
          //this.EmbryoTransFerEndInfo = this.CurrentIvfEmbryoTransferAttemptByCycleCodeController[0];
          //if (this.EmbryoTransFerEndInfo.TransferEndDate != null) {
          //  var SValidFrom = new Date(this.EmbryoTransFerEndInfo.TransferEndDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.TransferEndDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
          //this.LoadScansData();
          //this.LoadActorCode();
          //this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  //GetCycleActivity(l: TreatmentCycleActiityMasterController): number {
  //  if (l.DocDate == new Date(this.TransferDate)) {
  //    return l.CycleActivityCode
  //  }

  //}

  //GetCycleActivity(ActorCode: string, Transferdate: string): TreatmentCycleActiityMasterController[] {
  //  return this.CurrentTreatmentCycleActiityMasterController.filter(
  //    function (v, i, d) {
  //      return v.ActorID == ActorCode && 
  //    }
  //  )

  //}



  GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
    if (l.Grade6 != null) {
      return l.Grade6
    }
    else if (l.Grade5 != null) {
      return l.Grade5
    }
    else if (l.Grade4 != null) {
      return l.Grade4
    }
    else if (l.Grade3 != null) {
      return l.Grade3
    }
    else if (l.Grade2 != null) {
      return l.Grade2
    }
    else if (l.Grade1 != null) {
      return l.Grade1
    }
    return "";

  }
  GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
    if (l.DOC1 != null) {
      return l.DOC1
    }
    else if (l.DOC2 != null) {
      return l.DOC2
    }
    else if (l.DOC3 != null) {
      return l.DOC3
    }
    else if (l.DOC4 != null) {
      return l.DOC4
    }
    else if (l.DOC5 != null) {
      return l.DOC5
    }
    else if (l.DOC6 != null) {
      return l.DOC6
    }
    return 0;

  }
  GetMaxImageUrl(l: SingleWellCultureByCycleCodeController): string {
    if (l.DocID6 != null) {
      return l.DocFriendlyName6
    }
    else if (l.DocID5 != null) {
      return l.DocFriendlyName5
    }
    else if (l.DocID4 != null) {
      return l.DocFriendlyName4
    }
    else if (l.DocID3 != null) {
      return l.DocFriendlyName3
    }
    else if (l.DocID2 != null) {
      return l.DocFriendlyName2
    }
    else if (l.DocID1 != null) {
      return l.DocFriendlyName1
    }
    return null;

  }
  //LoadEmbryoTransfer2() {
  //  this.printService.onDataReady();
  //}
  //CurrentOocyteQualityAssessmentByCodeController: OocyteQualityAssessmentByCodeController[];
  //CurrentOocyteQualityAssessmentByCodeRequest: OocyteQualityAssessmentByCodeRequest;
  //OocyteQualityCode: any;


  //LoadScansData() {
  //  //alert("ScansData")
  //  this.CurrentOocyteQualityAssessmentByCodeRequest = new OocyteQualityAssessmentByCodeRequest();
  //  //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
  //  //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
  //  //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
  //  //this.OocyteQualityCode = this.route.snapshot.paramMap.get('OQACodedata');
  //  this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
  //  this.CurrentOocyteQualityAssessmentByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetOocyteQualityAssessmentByCodeController();
  //}


  //GetOocyteQualityAssessmentByCodeController() {
  //  this.StartRefreshing();
  //  this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.TreatmentCycleCode;
  //  //this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.OocyteQualityCode;
  //  //this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.SelectedpatientDetails.TreatmentCycleCode;
  //  //this.CurrentOocyteQualityAssessmentByCodeRequest.ConditionalOperator = 10;

  //  //alert(this.FormattedCode);
  //  this.actorservice.GetOocyteQualityAssessmentByCodeController(this.CurrentOocyteQualityAssessmentByCodeRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
  //        this.CurrentOocyteQualityAssessmentByCodeController = this.ApiResData.Result;
  //        //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
  //        //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

  //        //data.forEach((v, i, a) => {
  //        //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
  //        //});
  //        //for (let index = 0; index < data.length; index++){
  //        //    //alert(data[index].SingleWellFollicleCoder);

  //        //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
  //        //}
  //        //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
  //        //   alert(this.FollicularOocyteInfo.TreatmentCycle);
  //        //if (this.FollicularScanEndInfo.ScanDate != null) {
  //        //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
  //        //  if (SValidFrom.getFullYear() > 1900) {
  //        //    console.log('this.UpdateDate >1990');
  //        //    this.ScanDate = {

  //        //      year: SValidFrom.getFullYear(),
  //        //      month: SValidFrom.getMonth() + 1,
  //        //      day: SValidFrom.getDate()
  //        //    }
  //        //  }
  //        //}
  //        //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
  //        //  = this.FollicularScanEndInfo.EndometriumThickness;
  //        //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
  //        //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

  //        //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

  //        this.stopRefreshing();
  //        this.printService.onDataReady();

  //        //   this.LoadGuardian();
  //        //this.LoadMessages();


  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );

  //}

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.ProtocolStart = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEnd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.Surgeon = this.route.snapshot.paramMap.get('Surgeon');
    this.AsstSurgeon = this.route.snapshot.paramMap.get('AsstSurgeon');
    this.Embryologist = this.route.snapshot.paramMap.get('Embryologist');
    this.Anaesthesiologist = this.route.snapshot.paramMap.get('Anaesthesiologist');
    this.Anaesthesia = this.route.snapshot.paramMap.get('Anaesthesia');
    this.PlannedTime = this.route.snapshot.paramMap.get('PlannedTime');
    this.ActualDate = this.route.snapshot.paramMap.get('ActualDate');
    this.ActualTime = this.route.snapshot.paramMap.get('ActualTime'); 
    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.CultureMedia = this.route.snapshot.paramMap.get('CultureMedia');
    this.Method = this.route.snapshot.paramMap.get('Method');
    this.CatheterType = this.route.snapshot.paramMap.get('CatheterType');
    this.CatheterUsed = this.route.snapshot.paramMap.get('CatheterUsed');
    this.SpeculumUsed = this.route.snapshot.paramMap.get('SpeculumUsed');
    this.CervicalCleaning = this.route.snapshot.paramMap.get('CervicalCleaning');
    this.RetainedEmbryos = this.route.snapshot.paramMap.get('RetainedEmbryos');
    this.Fragmentation = this.route.snapshot.paramMap.get('Fragmentation');
    this.CervicalMucus = this.route.snapshot.paramMap.get('CervicalMucus');
    this.Technique = this.route.snapshot.paramMap.get('Technique');
    this.BloodOnCatheter = this.route.snapshot.paramMap.get('BloodOnCatheter');
    this.Retransfer = this.route.snapshot.paramMap.get('Retransfer');
    this.EmbryoTransfer = this.route.snapshot.paramMap.get('EmbryoTransfer');
    this.ActorCode = this.route.snapshot.paramMap.get('ActorCode');
    this.DSADOC = this.route.snapshot.paramMap.get('DSADOC');
    this.DSASTIMULATION = this.route.snapshot.paramMap.get('DSASTIMULATION');
    this.DSAANTAG = this.route.snapshot.paramMap.get('DSAANTAG');
    //this.ActivityCode = this.route.snapshot.paramMap.get('ActivityCode');
    //this.TransferDatenew = this.route.snapshot.paramMap.get('TransferDatenew');
    
    //let Code: number[] = this.ActivityCode;
    //alert(Code[0]);
    //alert(Code[1]);
    //alert(Code[2]);
    //alert(Code[3]);
    //alert(this.Code);
    //this.OvulationTriggerTime = this.route.snapshot.paramMap.get('OvulationTriggerTime');
    this.LoadOvariesData();
    
    //this.LoadOvariesData();
    //this.LoadMasterReq();
    //this.LoadTestData();
    //this.LoadMedicineData();

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








